import { BaseItem, NullablePartial } from './common';
import { PatientCalendarEntry } from './calendarSync';

export enum FhirMatching {
  NoRecordFound = 'NO_RECORD_FOUND',
  MultipleRecordsFound = 'MULTIPLE_RECORDS_FOUND',
  OneRecordFound = 'ONE_RECORD_FOUND',
}

export interface BaseEhrInformation {
  practiceId: string;
  patientId: string;
  value: string;
  createdByNotableInEhrTimestamp: Date | null;
  createdByNotableInEhrReason: FhirMatching | null;
  lastPatientEhrLoginTimestamp: Date | null;
  isTest: boolean | null;
}

export interface CreateValues extends NullablePartial<BaseEhrInformation> {}

export interface UpdateValues
  extends Partial<
    Pick<
      BaseEhrInformation,
      | 'value'
      | 'createdByNotableInEhrTimestamp'
      | 'createdByNotableInEhrReason'
      | 'lastPatientEhrLoginTimestamp'
      | 'practiceId'
      | 'isTest'
    >
  > {}

export interface EhrInformation extends BaseEhrInformation, BaseItem {}

export interface ImportRow {
  firstName: PatientCalendarEntry['firstName'];
  lastName: PatientCalendarEntry['lastName'];
  dateOfBirth: PatientCalendarEntry['dateOfBirth'];
  patientEhrId: PatientCalendarEntry['patientEhrId'];
  cellPhoneNumber?: PatientCalendarEntry['cellPhoneNumber'];
  email?: PatientCalendarEntry['email'];
}

export const IMPORT_COLUMNS: (keyof ImportRow)[] = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'patientEhrId',
  'cellPhoneNumber',
  'email',
];

export const EHR_GENERATED_PREFIX = 'generated_';
